/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Filters_Form_Aria_LabelInputs */

const en_video_filters_form_aria_label = /** @type {(inputs: Video_Filters_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video Filters`)
};

const fr_video_filters_form_aria_label = /** @type {(inputs: Video_Filters_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtres video`)
};

const de_video_filters_form_aria_label = /** @type {(inputs: Video_Filters_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videofilter`)
};

const it_video_filters_form_aria_label = /** @type {(inputs: Video_Filters_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtri video`)
};

const ru_video_filters_form_aria_label = /** @type {(inputs: Video_Filters_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видеофильтры`)
};

const es_video_filters_form_aria_label = /** @type {(inputs: Video_Filters_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtros de vídeo`)
};

const zh_cn2_video_filters_form_aria_label = /** @type {(inputs: Video_Filters_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频滤镜`)
};

const ja_video_filters_form_aria_label = /** @type {(inputs: Video_Filters_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオフィルター`)
};

const hi_video_filters_form_aria_label = /** @type {(inputs: Video_Filters_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो फ़िल्टर`)
};

const pt_pt2_video_filters_form_aria_label = /** @type {(inputs: Video_Filters_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtros de vídeo`)
};

/**
* | output |
* | --- |
* | "Video Filters" |
*
* @param {Video_Filters_Form_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_filters_form_aria_label = /** @type {((inputs?: Video_Filters_Form_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Filters_Form_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_filters_form_aria_label(inputs)
	if (locale === "de") return de_video_filters_form_aria_label(inputs)
	if (locale === "it") return it_video_filters_form_aria_label(inputs)
	if (locale === "ru") return ru_video_filters_form_aria_label(inputs)
	if (locale === "es") return es_video_filters_form_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_video_filters_form_aria_label(inputs)
	if (locale === "ja") return ja_video_filters_form_aria_label(inputs)
	if (locale === "hi") return hi_video_filters_form_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_video_filters_form_aria_label(inputs)
	return en_video_filters_form_aria_label(inputs)
});